'use client'

import { PRODUCT_LIST_SEO_CONTENT_ID } from '@/feature/product-list/services/productList.constant'
import { useIsReactNativeWebView } from '@/lib/react-native/contexts/react-native/ReactNativeProvider.client'
import type { TrackingGaEvent } from '@/lib/tracking/services/tracking.eventTypes'
import { Breadcrumb, type BreadcrumbCrumb } from '@/ui/breadcrumb/Breadcrumb.client'
import { formatCatalogBreadcrumbs } from '@/ui/breadcrumb/breadcrumb.utils'
import { Container } from '@/ui/layouts/container/Container'
import { Section } from '@/ui/layouts/section/Section'
import { ReadMore } from '@/ui/read-more-link/ReadMore.client'
import type React from 'react'

type ListHeaderProps = {
  children: React.ReactNode
  rawBreadcrumbs?: BreadcrumbCrumb[]
  seoContent?: string | null
}

export function ListHeader({ children, rawBreadcrumbs, seoContent }: ListHeaderProps) {
  const breadcrumbs = formatCatalogBreadcrumbs(rawBreadcrumbs)
  const isInWebView = useIsReactNativeWebView()

  return (
    <Container className="embed:my-3">
      {!isInWebView && !!breadcrumbs?.length && <Breadcrumb crumbs={breadcrumbs} />}
      <Section title="" className="pb-3 pt-0 embed:pb-0">
        {children}
      </Section>
      {!isInWebView && seoContent && (
        <ReadMore
          type="navigate"
          targetId={`#${PRODUCT_LIST_SEO_CONTENT_ID}`}
          text={seoContent}
          allowHtml
          trackingData={
            {
              event: 'gaEvent',
              eventCategory: 'page liste',
              eventAction: 'bloc seo',
              eventLabel: 'cta lire plus',
            } satisfies TrackingGaEvent
          }
        />
      )}
    </Container>
  )
}
